export const FETCH_INNER = {
  API_KEYS: 'FETCH_API_KEYS',
  API_KEYS_DETAILS: 'FETCH_API_KEYS_DETAILS',
  API_KEYS_WITH_TYPE: 'FETCH_API_KEYS_WITH_TYPE',
  BRANDS: 'FETCH_INNER_BRANDS',
  CATEGORIES: 'FETCH_INNER_CATEGORIES',
  SUBJECTS: 'FETCH_INNER_SUBJECTS',
  WAREHOUSE: 'FETCH_INNER_FILTER_WAREHOUSE',
};
